import React from 'react'

type DownloadIconProps = {
  color: string
}

export function DownloadIcon({ color }: DownloadIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      fill="none"
      viewBox="0 0 25 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M9.75 3a.75.75 0 01.75-.75h4a.75.75 0 01.75.75v4.75h3.25a.75.75 0 01.53 1.28l-6 6a.75.75 0 01-1.06 0l-6-6a.75.75 0 01.53-1.28h3.25V3zm1.5.75V8.5a.75.75 0 01-.75.75H8.31l4.19 4.19 4.19-4.19H14.5a.75.75 0 01-.75-.75V3.75h-2.5zM2.75 18.5a.75.75 0 01.75-.75h18a.75.75 0 010 1.5h-18a.75.75 0 01-.75-.75zM6.75 22a.75.75 0 01.75-.75h10a.75.75 0 010 1.5h-10a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  )
}
